import styled from 'styled-components';
import { media } from '../../../../../helpers/breakpoints';
import { StickyFooter as BaseStickyFooter } from '../../../../../components/Toolkit/StickyFooter/StickyFooter';
import { Button as BaseButton } from '../../../../../components/Toolkit/Button';

export const Button = styled(BaseButton)`
  flex: 1 0 50%;

  ${media.medium} {
    flex: 0 1 288px;
  }
`;
export const FooterText = styled.span`
  flex: 1 0 50%;
  padding-right: ${({ theme }) => theme.spacing.M24};
  ${({ theme }) => theme.fontSize.L18};
  color: ${({ theme }) => theme.colors.GREY_DARK};

  ${media.medium} {
    flex: 1 0 auto;
  }
  & strong {
    font-weight: ${({ theme }) => theme.fontWeight.bold};
  }
`;
export const FooterContentWrapper = styled.div`
  display: flex;
  align-items: center;
  max-width: 75rem;
  margin: 0 auto;
`;
export const StickyFooter = styled(BaseStickyFooter)`
  ${media.large} {
    padding: ${({ theme }) => theme.spacing.M16};
  }
`;
